import { createContext } from "react";
import { EventTypes } from "../config/app-globals.enum";
import { getIsCameFromEventDetailsPage, getReportedEventDropDownIndex } from "../services/LocalStorageService";

let ddIndex = EventTypes.SPEEDING;;

if (getIsCameFromEventDetailsPage() === 1) {
    ddIndex = (getReportedEventDropDownIndex() === null) ? EventTypes.SPEEDING : getReportedEventDropDownIndex()
}
const UserContext = createContext({ eventCategory: ddIndex, setEventCategory: (id) => { id = id } });

export const UserProvider = UserContext.Provider;
export const UserConsumer = UserContext.Consumer;


export default UserContext;
